export default __webpack_public_path__ + "static/media/3c36493c3aa1a2e2fec04820e3f1d6281576603954462.9096bcc3.webp";